<template>
    <div>
        <div class="outerWrapper" v-if="recList.length">
            <div class="recHeader">
                <div class="recHeader__inner">
                    <div class="recHeader__title">
                        <img src="/img/icons/jobscan_tie.png" />
                        <div class="titleWrapper">
                            <h4>Ideas for your career</h4>
                            <span>Based on your resume's transferrable skills</span>
                        </div>
                    </div>
                    <a @click="$router.go(-1)" class="backButton swell">
                        Update Resume
                    </a>
                </div>
            </div>
            <div class="recRow" v-for="(rec, index) in displayList" :key="rec.id">
                <div class="textIcon" :style="iconStyle(index)">{{ iconText(rec.jobTitle) }}</div>
                <div class="textWrapper">
                    <div class="title">
                        {{ rec.jobTitle }}
                    </div>
                    <div class="actions">
                        <a
                            :href="
                                `https://www.indeed.com/jobs?q=${encodeURIComponent(rec.jobTitle)}`
                            "
                            target="_blank"
                            class="jobLink action"
                        >
                            View Jobs
                        </a>
                        <span
                            v-if="cv"
                            class="jobLink action scan"
                            @click="scanResume(rec.content)"
                        >
                            View Report
                        </span>
                    </div>
                </div>
                <div class="tieRank">
                    <Rating :rating="rec.score" :scale="thresholdObject" />
                </div>
                <span v-if="cv" class="desktopScanLink" @click="scanResume(rec.content)">
                    View Report
                </span>
            </div>
            <div v-if="displayList.length < 100" class="loadMore" @click="loadMore">Load More</div>
        </div>
        <div v-else>
            <div class="errorBlock">Uh-oh. There are no results to display.</div>
        </div>
        <div class="acknowledgement">
            Job descriptions from
            <a href="https://www.betterteam.com/job-descriptions" target="_blank">Betterteam</a>
            .
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import Rating from './Rating'
import { scan } from '../../api/genericJobs'
export default {
    name: 'ResultsTable',
    components: { Rating },
    props: {
        recommendations: {
            type: Array,
        },
        ties: {
            type: Array,
        },
    },
    data() {
        return {
            colorArray: ['#3193C1', '#E0A42E', '#35A88C', '#8C4DBE'],
            chunkBy: 10,
            page: 1,
        }
    },
    computed: {
        cv: function() {
            return localStorage.career_change_cv
        },
        recList: function() {
            const list = this.recommendations || this.retrieveRecs() || []
            return this.formatRecs(list)
        },
        displayList: function() {
            return _.take(this.recList, this.chunkBy * this.page)
        },
        thresholdObject: function() {
            const avg = _.meanBy(this.recList.slice(0, 20), 'score')

            let ret = {
                one: 0,
                two: avg * 0.7,
                three: avg * 0.9,
                four: avg * 1.075,
                five: avg * 1.3,
            }
            return ret
        },
    },
    methods: {
        loadMore() {
            if (this.displayList.length <= 100) {
                this.page++
            }
        },
        iconStyle(index) {
            const color = this.colorArray[index % this.colorArray.length]
            return {
                color,
                'background-color': `${color}15`,
            }
        },
        storeRecs: function(recs) {
            localStorage.setItem('jdRecs', JSON.stringify(recs))
        },
        retrieveRecs: function() {
            return JSON.parse(localStorage.getItem('jdRecs'))
        },
        formatRecs: function(list) {
            const sortedList = list.sort((a, b) => {
                return b.score - a.score
            })
            const highVal = sortedList[0].score
            const normalizedScoreList = sortedList.map(rec => {
                rec.normalizedScore = rec.score / highVal
                return rec
            })
            return normalizedScoreList
        },
        iconText: function(jobTitle) {
            return jobTitle
                .split(' ')
                .map(str => str[0])
                .slice(0, 2)
                .join('')
                .toUpperCase()
        },
        scanResume: async function(jd) {
            const cv = localStorage.career_change_cv
            const resp = await scan(cv, jd)
            if (resp.error || !resp.id) {
                showNotify('Unable to complete scan. Please try again.', 'error')
                return
            }
            const baseDomain = window.location.hostname.replace(/^www\./, '')
            window.location.href = `https://app.${baseDomain}/match-report/${resp.id}`
        },
    },
    mounted: function() {
        if (this.recommendations) {
            this.storeRecs(this.recommendations)
        }
    },
}
</script>

<style lang="less" scoped>
h2 {
    position: relative;
    margin: 0;
    padding: 1em 2em;
    background-color: #2aacea;
    border-top-right-radius: 12px;
    border-top-left-radius: 12px;
    color: white;
    border-bottom: solid 2px rgba(255, 255, 255, 0.5);
    img {
        max-width: 125px;
        position: absolute;
        bottom: 0;
        right: 0.5em;
        z-index: 100;
    }
    @media screen and (max-width: 480px) {
        img {
            display: none;
        }
    }
}
.outerWrapper {
    background-color: white;
    box-shadow: 0px -0.465507px 5.12058px rgba(62, 121, 160, 0.0282725),
        0px -1.56354px 17.199px rgba(62, 121, 160, 0.0417275);
}
.recHeader {
    padding: 9px;
    box-sizing: border-box;
    .recHeader__inner {
        background-color: #1f344c;
        border-radius: 3px;
        box-sizing: border-box;
        padding: 1.25em 2em;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        flex-wrap: nowrap;
        img {
            width: 48px;
            margin-right: 1em;
            @media screen and (max-width: 425px) {
                display: none;
            }
        }
        .recHeader__title {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: flex-start;
            .titleWrapper {
                h4 {
                    color: white;
                    text-transform: none;
                    letter-spacing: normal;
                    margin-bottom: 2px;
                    font-size: 1.25em;
                    font-weight: 600;
                    margin-top: 0;
                }
                span {
                    color: #b6bed1;
                }
            }
        }
        .backButton {
            background-color: #2aacea;
            color: white;
            padding: 0.5em 1em;
            text-transform: uppercase;
            border: none;
            font-size: 0.9em;
            font-weight: 600;
            text-decoration: none;
            @media screen and (max-width: 768px) {
                display: none;
            }
        }
    }
}
.recRow {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-start;
    padding: 1em 2.5em;
    color: #4a4a4a;
    background-color: white;
    border-bottom: 1px solid #edf2f5;
    div {
        font-weight: inherit;
    }
    .miniTie {
        width: 30px;
    }
    .tieRank {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: flex-end;
        padding: 0.5em;
        border-radius: 48px;
        overflow: hidden;
        flex: 1;
    }
    .textWrapper {
        flex: 3;
        .title {
            font-size: 1.25em;
            text-decoration: none;
            color: inherit;
            font-weight: 600;
            flex: 3;
            margin-bottom: 3px;
        }
        .actions {
            color: lightgray;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: flex-start;
            .action {
                text-align: right;
                color: #2aacea;
                text-decoration: none;
                font-weight: normal;
                text-transform: uppercase;
                font-size: 0.9em;
                cursor: pointer;
                &:hover {
                    font-weight: bold;
                }
                &.scan {
                    display: none;
                    margin-left: 6px;
                    padding-left: 6px;
                    border-left: solid 1px #f4f4f4;
                    white-space: nowrap;
                    @media screen and (max-width: 768px) {
                        display: block;
                    }
                }
            }
        }
        @media screen and (max-width: 768px) {
            flex: 2;
        }
    }
    .textIcon {
        width: 45px;
        height: 45px;
        border-radius: 50%;
        background-color: #f0f8ff;
        color: #2aacea;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-weight: 600;
        font-size: 1.25em;
        margin-right: 1em;
        @media screen and (max-width: 375px) {
            display: none;
        }
    }
}
.errorBlock {
    display: block;
    width: 100%;
    border-radius: 12px;
    color: #ff6565;
    background-color: #fff5f5;
    padding: 2em;
    font-weight: bold;
    font-size: 1.25em;
}

@media screen and (max-width: 468px) {
    .recRow {
        padding: 1em 1em;
        .title {
            font-size: 1em;
        }
    }
}

.loadMore {
    display: float;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 2em;
    font-weight: bold;
    font-size: 0.9em;
    text-transform: uppercase;
    text-align: center;
    cursor: pointer;
    &:hover {
        color: #2aacea;
    }
}

.acknowledgement {
    display: block;
    width: 100%;
    padding: 1em;
    box-sizing: border-box;
    text-align: center;
    font-size: 0.9em;
    font-style: italic;
    color: #b0b0b0;
    a {
        color: #2aacea;
    }
}

.desktopScanLink {
    padding: 0.5em 2em;
    border-left: 1px solid #f4f4f4;
    border-right: 1px solid transparent;
    color: #2aacea;
    cursor: pointer;
    margin-left: 2em;
    text-align: center;
    text-transform: uppercase;
    box-sizing: border-box;
    transition: all ease 250ms;
    &:hover {
        border: solid 1px #2aacea;
        border-radius: 48px;
    }
    &:active {
        background-color: #2aacea;
        color: white;
    }
    @media screen and (max-width: 768px) {
        display: none;
    }
}
</style>
